const data = [
  {
    label: "Vencimiento Licencia A3",
    field: 'license_expiration'
  },
  {
    label: "Vencimiento DNI",
    field: 'doc_expiration'
  },
  {
    label: "Vencimiento EMO",
    field: 'emo_expiration'
  },
  {
    label: "Vencimiento SCTR",
    field: 'sctr_expiration'
  },
  {
    label: "Vencimiento Licencia A4",
    field: 'a4_expiration'
  },
  {
    label: "Vencimiento antecedentes penales",
    field: 'criminal_records_expiration'
  },
  {
    label: "Vencimiento antecedentes policiales",
    field: 'police_records_expiration'
  },
  {
    label: "Vencimiento carnet PANASA",
    field: 'panasa_expiration'
  },
  {
    label: "Vencimiento carnet UNT",
    field: 'unt_expiration'
  },
  {
    label: "Vencimiento curso seguridad portuaria",
    field: 'port_security_expiration'
  },
  {
    label: "Vencimiento curso PBIP",
    field: 'pbip_expiration'
  },
  {
    label: "Vencimiento curso mercadería peligrosa",
    field: 'dangerous_merch_expiration'
  },
]

export default data;
